import React, {
  useState,
  useEffect,
  useContext,
} from "react";

import { TranslatorContext } from "../../context/Translator";
import Modal from "react-bootstrap/Modal";
import { AnchorComponent, ButtonComponent } from "../elements";
import { Link } from "react-router-dom";

export default function MedicalTableComponent({
  thead,
  tbody,
}) {
  const { t } = useContext(TranslatorContext);

  const [alertModal, setAlertModal] =
    useState(false);

  const [data, setData] = useState([]);

  const [selectedItem, setSelectedItem] =
    useState(null);

  /*
  |--------------------------------------------------------------------------
  | Update Table Data
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    setData(tbody || []);
  }, [tbody]);

  /*
  |--------------------------------------------------------------------------
  | Checkbox
  |--------------------------------------------------------------------------
  */

  const handleCheckbox = (event) => {
    const {
      name,
      checked,
    } = event.target;

    if (name === "allCheck") {
      const checkData = data.map(
        (item) => ({
          ...item,
          isChecked: checked,
        })
      );

      setData(checkData);
    } else {
      const checkData = data.map(
        (item) =>
          String(item.id) === String(name)
            ? {
              ...item,
              isChecked: checked,
            }
            : item
      );

      setData(checkData);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Delete Modal
  |--------------------------------------------------------------------------
  */

  const openDeleteModal = (item) => {
    setSelectedItem(item);
    setAlertModal(true);
  };

  /*
  |--------------------------------------------------------------------------
  | Close Modal
  |--------------------------------------------------------------------------
  */

  const closeDeleteModal = () => {
    setSelectedItem(null);
    setAlertModal(false);
  };

  /*
  |--------------------------------------------------------------------------
  | Delete
  |--------------------------------------------------------------------------
  */

  const handleDelete = async () => {
    if (!selectedItem) {
      return;
    }

    console.log(
      "Delete Medical Care:",
      selectedItem.id
    );

    /*
    |--------------------------------------------------------------------------
    | Add delete API here later
    |--------------------------------------------------------------------------
    */

    closeDeleteModal();
  };

  /*
  |--------------------------------------------------------------------------
  | Currency
  |--------------------------------------------------------------------------
  */

  const formatAmount = (amount) => {
    const value = Number(amount || 0);

    return value.toLocaleString("en-PK");
  };

  return (
    <div className="mc-table-responsive">

      <table className="mc-table product">

        {/* ==========================================================
            HEADER
        ========================================================== */}

        <thead className="mc-table-head primary">

          <tr>

            {thead.map(
              (item, index) => (
                <th key={index}>
                  {t(item)}
                </th>
              )
            )}

          </tr>

        </thead>

        {/* ==========================================================
            BODY
        ========================================================== */}

        <tbody className="mc-table-body even">

          {data.length > 0 ? (

            data.map(
              (item, index) => (

                <tr key={item.id || index}>

                  {/* ==================================================
                      FAMILY
                  ================================================== */}

                  <td title={item.f_number || ""}>

                    <div className="mc-table-check">

                      <p className="mb-0">

                        {item.f_number || "-"}

                      </p>

                    </div>

                  </td>

                  {/* ==================================================
                      PERSON
                  ================================================== */}

                  <td>

                    {item.person_name || "-"}

                  </td>

                  {/* ==================================================
                      RELATION
                  ================================================== */}

                  <td>

                    {item.relation || "-"}

                  </td>
                  <td>

                    {item.date_of_treatment || "-"}

                  </td>
                  <td>

                    {item.treatment_way === 1 ? "Mobile Health Van" : "Referred to Hospital"}

                  </td>

                  {/* ==================================================
                      DOCTOR
                  ================================================== */}

                  <td>

                    {item.doctor_name || "-"}

                  </td>



                  {/* ==================================================
                      HOSPITAL
                  ================================================== */}

                  <td>

                    <div className="mc-table-check">

                      <p className="mb-0">

                        {item.hospital_name || "-"}

                      </p>

                    </div>

                  </td>

                  {/* ==================================================
                      MEDICINE AMOUNT
                  ================================================== */}

                  <td>

                    {formatAmount(
                      item.medicine_amount
                    )}

                  </td>

                  {/* ==================================================
                      DOCTOR FEE
                  ================================================== */}

                  <td>

                    {formatAmount(
                      item.doctor_fee
                    )}

                  </td>

                  {/* ==================================================
                      TOTAL AMOUNT
                  ================================================== */}

                  <td>

                    <strong>

                      {formatAmount(
                        item.total_amount
                      )}

                    </strong>

                  </td>

                  {/* ==================================================
                      MEDICAL REASON
                  ================================================== */}

                  <td
                    title={
                      item.medical_reason ||
                      ""
                    }
                  >

                    <div
                      style={{
                        maxWidth: "220px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow:
                          "ellipsis",
                      }}
                    >

                      {item.medical_reason ||
                        "-"}

                    </div>

                  </td>

                  {/* ==================================================
                      STATUS
                  ================================================== */}

                  {/* <td>

                    <span
                      className={
                        String(
                          item.status
                        ).toLowerCase() ===
                        "approved"
                          ? "badge bg-success"
                          : String(
                              item.status
                            ).toLowerCase() ===
                            "rejected"
                          ? "badge bg-danger"
                          : "badge bg-warning text-dark"
                      }
                    >

                      {item.status ||
                        "Pending"}

                    </span>

                  </td> */}

                  {/* ==================================================
                      ACTIONS
                  ================================================== */}

                  <td>

                    <div className="mc-table-action">

                      {/* EDIT */}

                      <AnchorComponent
                        to={`/medical-care/edit/${item.id}`}
                        title="Edit"
                        className="material-icons edit"
                      >
                        {item.action?.edit ||
                          "edit"}
                      </AnchorComponent>

                      <Link
                        to={`/medical-care/view/${item.id}`}
                        className="material-icons visibility"
                      >
                        visibility
                      </Link>

                    </div>

                  </td>

                </tr>

              )
            )

          ) : (

            <tr>

              <td
                colSpan={thead.length}
                className="text-center py-4"
              >

                No Medical Care Found

              </td>

            </tr>

          )}

        </tbody>

      </table>

      {/* ============================================================
          DELETE MODAL
      ============================================================ */}

      <Modal
        show={alertModal}
        onHide={closeDeleteModal}
        centered
      >

        <div className="mc-alert-modal">

          <i className="material-icons">
            new_releases
          </i>

          <h3>
            Are you sure!
          </h3>

          <p>
            Want to delete this medical
            care record?
          </p>

          {selectedItem && (
            <p className="text-muted">

              <strong>
                {selectedItem.f_number}
              </strong>

              {" - "}

              {selectedItem.person_name}

            </p>
          )}

          <Modal.Footer>

            <ButtonComponent
              type="button"
              className="btn btn-secondary"
              onClick={
                closeDeleteModal
              }
            >
              {t("close")}
            </ButtonComponent>

            <ButtonComponent
              type="button"
              className="btn btn-danger"
              onClick={handleDelete}
            >
              {t("delete")}
            </ButtonComponent>

          </Modal.Footer>

        </div>

      </Modal>

    </div>
  );
}